
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"applicationFormMedicalHistoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"applicationFormMedicalHistory"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"family_physician"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telephone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birth_weight_lbs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birth_weight_oz"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pregnancy_length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pregnancy_complications"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pregnancy_complications_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"head_brain_injury"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"head_brain_injury_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"head_brain_injury_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surgeries"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surgeries_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures_frequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures_length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures_medications"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures_medications_list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures_medications_previously"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seizures_medications_previously_list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"other_medications"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"other_medications_list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medical_problems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medical_problems_list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"broken_limbs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"broken_limbs_list"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":679}};
    doc.loc.source = {"body":"fragment applicationFormMedicalHistoryFields on applicationFormMedicalHistory {\n  form_id\n  family_physician\n  telephone\n  address\n  birth_weight_lbs\n  birth_weight_oz\n  pregnancy_length\n  pregnancy_complications\n  pregnancy_complications_description\n  head_brain_injury\n  head_brain_injury_description\n  head_brain_injury_date\n  surgeries\n  surgeries_description\n  seizures\n  seizures_frequency\n  seizures_length\n  seizures_type\n  seizures_medications\n  seizures_medications_list\n  seizures_medications_previously\n  seizures_medications_previously_list\n  other_medications\n  other_medications_list\n  medical_problems\n  medical_problems_list\n  broken_limbs\n  broken_limbs_list\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["applicationFormMedicalHistoryFields"] = oneQuery(doc, "applicationFormMedicalHistoryFields");
        
